import { render, staticRenderFns } from "./AttacksCountByBrands.vue?vue&type=template&id=66ed82a6&scoped=true"
import script from "./AttacksCountByBrands.vue?vue&type=script&lang=ts"
export * from "./AttacksCountByBrands.vue?vue&type=script&lang=ts"
import style0 from "./AttacksCountByBrands.vue?vue&type=style&index=0&id=66ed82a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ed82a6",
  null
  
)

export default component.exports